import { Price } from "@/models/Price"

const factors: Record<string, number> = {
  AUD: 100.0,
  USD: 100.0,
  CAD: 100.0,
  NZD: 100.0,
  EUR: 100.0,
  GBP: 100.0,
} as const

export type SupportedCurrency = keyof typeof factors

const prefixes: Record<SupportedCurrency, string> = {
  AUD: "$",
  USD: "$",
  CAD: "$",
  NZD: "$",
  EUR: "€",
  GBP: "£",
} as const

export function formatAmount(unitAmount: number, currency: SupportedCurrency) {
  const factor = factors[currency]

  if (!factor) return

  const prefix = prefixes[currency]
  const suffix = prefix == "$" ? " " + currency : ""

  return `${prefix}${(unitAmount / factor).toFixed(2)}${suffix}`
}

export function formatAmount2({
  unitAmount,
  currency,
}: {
  unitAmount: number
  currency: SupportedCurrency
}) {
  return formatAmount(unitAmount, currency)
}

export function formatPeriod(pricing: Price) {
  if (pricing.period == null) {
    return ""
  }

  const unit = pricing.period.unit
  const duration = pricing.period.duration
  const iterations = pricing.iterations

  let iterationUnit = ""

  if (iterations) {
    iterationUnit = `for ${iterations} payments`
  }
  if (duration > 1) {
    return `/ ${duration} ${unit}s ${iterationUnit}`
  } else {
    return `/ ${unit} ${iterationUnit}`
  }
}
